import React from 'react';
import {
  PlusOutlined,
  DeleteOutlined,
  DownOutlined,
  UpOutlined,
  LoadingOutlined,
  InboxOutlined,
  UploadOutlined,
} from '@ant-design/icons';

// Re-export everything from antd so webpack can statically resolve named
// imports (Form, Table, Card, etc.) that @uform/antd pulls in alongside Icon.
export * from 'antd';

const typeMap = {
  plus: PlusOutlined,
  delete: DeleteOutlined,
  down: DownOutlined,
  up: UpOutlined,
  loading: LoadingOutlined,
  inbox: InboxOutlined,
  upload: UploadOutlined,
};

// Legacy antd v3 Icon shim for @uform/antd compatibility.
export function Icon({ type, ...props }) {
  const Component = typeMap[type] || null;
  if (!Component) return null;
  return React.createElement(Component, props);
}
